import { render, staticRenderFns } from "./babsDetayMailCellRenderer.vue?vue&type=template&id=1922b4bf&"
import script from "./babsDetayMailCellRenderer.vue?vue&type=script&lang=js&"
export * from "./babsDetayMailCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports